import Vue from 'vue'
Vue.use(require('vue-moment'))
export default {
  statusHidden: 'hidden',
  statusCancelled: 'cancelled',
  openBookingTypeAlways: 'always',
  openBookingTypeBefore: 'before',
  openBookingTypeAfter: 'after',
  openBookingTypeInterval: 'interval',
  readableMinMax(min, max) {
    if (min === '' || min == '0' || min === undefined) {
      min = '-'
    }
    if (max === '' || max == '0' || max === undefined) {
      max = '&#8734;'
    }
    return min + ' / ' + max
  },
  readableCount(count, max) {
    if (max === '' || max === undefined) {
      max = '&#8734;'
    }
    return count + ' / ' + max
  },
  readableTime(start, end) {
    start = Vue.moment(start).format('HH:mm')
    end = Vue.moment(end).format('HH:mm')
    return start + ' - ' + end
  },
  readableDate(start, end) {
    start = Vue.moment(start).format('DD MMM Y - HH:mm')
    end = Vue.moment(end).format('HH:mm')
    return start + ' - ' + end
  },
  readableResponsables(eventUsers) {
    if (Core.Validation.isEmpty(eventUsers)) {
      return '-'
    }
    return eventUsers
  },
  readablePlace(place) {
    if (Core.Validation.isEmpty(place)) {
      return '-'
    }
    return place
  },
  readableDescription(description, emptyText) {
    if (emptyText === undefined) {
      emptyText = '-'
    }
    if (Core.Validation.isEmpty(description)) {
      return emptyText
    }
    return description
  },
  readableBookingCount(eventBookingCount,max) {
    if (eventBookingCount === undefined) {
      eventBookingCount = 0
    }
    if (max == '0') {
      return eventBookingCount
    } else {
      return eventBookingCount + '/' + max
    }
  },
  readableText(text, emptyText) {
    if (emptyText === undefined) {
      emptyText = '-'
    }
    if (Core.Validation.isEmpty(text)) {
      return emptyText
    }
    return text
  },
  getOpenBookingLabel(status) {
    switch(status) {
      case this.openBookingTypeAlways:
        return Core.Definition.getDefinition('Toujours ouvert');
        break
      case this.openBookingTypeAfter:
        return Core.Definition.getDefinition('Après');
        break
      case this.openBookingTypeBefore:
        return Core.Definition.getDefinition('Avant');
        break
      case this.openBookingTypeInterval:
        return Core.Definition.getDefinition('Intervale');
        break
      default:
        return ''
        break
    }
  },
  getOpenBookingOptions(keys) {
    if (keys === undefined) {
      keys = [this.openBookingTypeAlways, this.openBookingTypeAfter, this.openBookingTypeBefore, this.openBookingTypeInterval]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.getOpenBookingLabel(key)
          }
      )
    }
    return options
  }
}
